import React from 'react';
import PropTypes from 'prop-types';
import '../../styles/animations.css';

/**
 * AnimatedElement - A wrapper component that adds animations to any element
 * 
 * @param {object} props - Component props
 * @param {string} props.type - Animation type (fade-in, slide-up, slide-right, slide-left, scale-in)
 * @param {string} props.duration - Animation duration (300, 500, 700, 1000)
 * @param {string} props.delay - Animation delay (100, 200, 300, 400, 500)
 * @param {string} props.className - Additional CSS classes
 * @param {React.ReactNode} props.children - Child elements
 * @returns {React.ReactElement}
 */
const AnimatedElement = ({ 
  type = 'fade-in', 
  duration = '500', 
  delay = '0',
  className = '', 
  children,
  ...rest 
}) => {
  const animationClass = `animate ${type} duration-${duration}${delay ? ` delay-${delay}` : ''}`;
  
  return (
    <div className={`${animationClass} ${className}`} {...rest}>
      {children}
    </div>
  );
};

AnimatedElement.propTypes = {
  type: PropTypes.oneOf(['fade-in', 'slide-up', 'slide-right', 'slide-left', 'scale-in']),
  duration: PropTypes.oneOf(['300', '500', '700', '1000']),
  delay: PropTypes.oneOf(['0', '100', '200', '300', '400', '500']),
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default AnimatedElement; 